export const sortMappingStatistics: Record<string, string> = {
  bookName: 'BookName',
  firmName: 'FirmName',
  //direction: 'Status', // not used
  //targetMarketValue: 'BookStatus', // not used
  gmv: 'GMV',
  netGMVRate: 'NetGMVRate',
  hitRate: 'HitRate',
  avgDur: 'AvgDur',
  bp: 'BP',
  gmvPctBp: 'GmvPctBp',
  avgBPRate: 'AvgBPRate',
  absReturnRate: 'AbsReturnRate',
  dailyPnl: 'DailyPnl',
  wtdPnl: 'WtdPnl',
  mtdPnl: 'MtdPnl',
  qtdPnl: 'QtdPnl',
  ytdPnl: 'YtdPnl',
  adjustedPnl: 'AdjustedPnl',
  //closedAt: 'AvgDeployment', // not used
}
